const API_BASE_URL = "https://ijves.org";

export default API_BASE_URL;
